@if (showAddLeadDialog) {
  <sps-lead-form [visible]="showAddLeadDialog" (leadFormClosed)="leadFormClosed()"></sps-lead-form>
}
<p-card [header]="i18n?.i18nLng()['NEWLEADTITLE']" class="card-secondary">
  <div class="line-height-3">
    {{ i18n.i18nLng()['NEWLEADINFO'] }}
  </div>
  <ng-template pTemplate="footer">
    <p-button icon="pi pi-plus-circle" [label]="i18n?.i18nLng()['ADDLEAD']" variant="outlined" (click)="addBusinessPartner()"/>
  </ng-template>
</p-card>
